<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5start#chap1">1</a></p>
<p class="toc1"><a href="#/6chap2#chap2">2</a></p>
<p class="toc1"><span href="#/7chap3#chap3" title="Link target outside of Sample">3</span></p>
<p class="toc1"><span href="#/8chap4#chap4" title="Link target outside of Sample">4</span></p>
<p class="toc1"><span href="#/9chap5#chap5" title="Link target outside of Sample">5</span></p>
<p class="toc1"><span href="#/10chap6#chap6" title="Link target outside of Sample">6</span></p>
<p class="toc1"><span href="#/11chap7#chap7" title="Link target outside of Sample">7</span></p>
<p class="toc1"><span href="#/12chap8#chap8" title="Link target outside of Sample">8</span></p>
<p class="toc1"><span href="#/13chap9#chap9" title="Link target outside of Sample">9</span></p>
<p class="toc1"><span href="#/14chap10#chap10" title="Link target outside of Sample">10</span></p>
<p class="toc1"><span href="#/15chap11#chap11" title="Link target outside of Sample">11</span></p>
<p class="toc1"><span href="#/16chap12#chap12" title="Link target outside of Sample">12</span></p>
<p class="toc1"><span href="#/17chap13#chap13" title="Link target outside of Sample">13</span></p>
<p class="toc1"><span href="#/18chap14#chap14" title="Link target outside of Sample">14</span></p>
<p class="toc1"><span href="#/19chap15#chap15" title="Link target outside of Sample">15</span></p>
<p class="toc1"><span href="#/20chap16#chap16" title="Link target outside of Sample">16</span></p>
<p class="toc1"><span href="#/21chap17#chap17" title="Link target outside of Sample">17</span></p>
<p class="toc1"><span href="#/22chap18#chap18" title="Link target outside of Sample">18</span></p>
<p class="toc1"><span href="#/23chap19#chap19" title="Link target outside of Sample">19</span></p>
<p class="toc1"><span href="#/24chap20#chap20" title="Link target outside of Sample">20</span></p>
<p class="toc1"><span href="#/25chap21#chap21" title="Link target outside of Sample">21</span></p>
<p class="toc1"><span href="#/26chap22#chap22" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/27biography#biography" title="Link target outside of Sample">A Biography of Patricia Gaffney</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?6b9e41de